import { Button, Dropdown, Menu } from 'antd';
import { useTranslation } from 'react-i18next';
import { DownOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";


const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [showLanguage, setShowLanguage] = useState(false);

  useEffect(() => {
    const saveShowLng = localStorage.getItem("showLanguage");
    setShowLanguage(saveShowLng === "true");
  }, [i18n.language]);

  const changeLanguage = (e: { key: any; }) => {
    i18n.changeLanguage(e.key);
  };

  const items = [
    { key: 'en', label: 'English' },
    { key: 'uk', label: 'Українська' },
    { key: 'ru', label: 'Русский' },
  ];


  if (!i18n.isInitialized || !showLanguage) {
    return null;
  }

  return (
    <Dropdown
      menu={{ items, onClick: changeLanguage }}
      trigger={['click']}
    >
      <Button>
        {i18n.language.toUpperCase()} <DownOutlined />
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher;
